import React from 'react';
import {Table} from 'semantic-ui-react';

const FOOTER_LABELS = [
  'Subtotal',
  'I.V.A',
  'Descuento',
  'Total',
];

function renderOrderType(item) {
  if (item === 'E') {
    return 'EMERGENTE';
  } else if (item === 'S') {
    return 'STOCK';
  } else if (item === 'P') {
    return 'ESPECIAL';
  }
  return '';
}

const DetailTable = ({items, invoice}) => {
  const {subtotal = 0.00, tax = 0.00, discount = 0.00, total = 0.00} = invoice;
  const footer = [subtotal, tax, discount, total];
  return (
    <Table striped celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>LINEA</Table.HeaderCell>
          <Table.HeaderCell>ITEM</Table.HeaderCell>
          <Table.HeaderCell>DESCRIPCIÓN</Table.HeaderCell>
          <Table.HeaderCell>TIPO PEDIDO</Table.HeaderCell>
          <Table.HeaderCell>CHASIS</Table.HeaderCell>
          <Table.HeaderCell>CANTIDAD</Table.HeaderCell>
          <Table.HeaderCell>PRECIO</Table.HeaderCell>
          <Table.HeaderCell>TOTAL</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {
          items.map((item, index) => (
            <Table.Row key={item.line}>
              <Table.Cell>{index + 1}</Table.Cell>
              <Table.Cell>{item.item}</Table.Cell>
              <Table.Cell>{item.description}</Table.Cell>
              <Table.Cell>{renderOrderType(item.orderType)}</Table.Cell>
              <Table.Cell>{item.chassis}</Table.Cell>
              <Table.Cell className="invoice-align-text-left">{item.quantity}</Table.Cell>
              <Table.Cell className="invoice-align-text-left">$ {item.price}</Table.Cell>
              <Table.Cell className="invoice-align-text-left">$ {item.total}</Table.Cell>
            </Table.Row>
          ))
        }
        {
          footer.map((item, index) => (
            <Table.Row key={index}>
              <Table.Cell/><Table.Cell/><Table.Cell/>
              <Table.Cell/><Table.Cell/><Table.Cell/>
              <Table.Cell className="invoice-detail-footer">{FOOTER_LABELS[index]}</Table.Cell>
              <Table.Cell className="invoice-align-text-left">{item ? `$ ${item}` : '$ 0.00'}</Table.Cell>
            </Table.Row>
          ))
        }
      </Table.Body>
    </Table>
  );
};

export default DetailTable;
